/**
 * Enum to provide a hint about the type of data that might be entered by the user while editing the element or its contents.
 * This allows the browser to display an appropriate virtual keyboard.
 */
var InputMode;
(function (InputMode) {
    /** Fractional numeric input keyboard that contains the digits and decimal separator for the user's locale (typically . or ,). */
    InputMode["DECIMAL"] = "decimal";
    /** A virtual keyboard optimized for entering email addresses. Typically includes the @ character as well as other optimizations. */
    InputMode["EMAIL"] = "email";
    /** No virtual keyboard. This is used when the page implements its own keyboard input control. */
    InputMode["NONE"] = "none";
    /** Numeric input keyboard that only requires the digits 0–9. Devices may or may not show a minus key. */
    InputMode["NUMERIC"] = "numeric";
    /** A virtual keyboard optimized for search input. For instance, the return/submit key may be labeled "Search". */
    InputMode["SEARCH"] = "search";
    /** A telephone keypad input that includes the digits 0–9, the asterisk (*), and the pound (#) key. */
    InputMode["TEL"] = "tel";
    /** Standard input keyboard for the user's current locale. */
    InputMode["TEXT"] = "text";
    /** A keypad optimized for entering URLs. This may have the / key more prominent, for example. */
    InputMode["URL"] = "url";
})(InputMode || (InputMode = {}));
export { InputMode, };
//# sourceMappingURL=input-constants.js.map